import { IBusinessUnitList, ICountryList, IProjectDetail, IRegionList } from "@redux/reducers/projectInitiationReducer";

export enum ActionType {
  BUSINESS_UNIT_LIST_USER_ID = "BUSINESS_UNIT_LIST_USER_ID",
  REGION_LIST_BY_BUSINESS_UNIT = "REGION_LIST_BY_BUSINESS_UNIT",
  COUNTRY_LIST_BY_REGION = "COUNTRY_LIST_BY_REGION",
  ALL_BUSINESS_UNIT_LIST = "ALL_BUSINESS_UNIT_LIST",
  PROJECT_DETAILS_BY_PID = "PROJECT_DETAILS_BY_PID",
  GET_ALL_EXTENDED_BU = "GET_ALL_EXTENDED_BU",
  GET_ALL_OTHERS_EXTENDED_BU = "GET_ALL_OTHERS_EXTENDED_BU",
  IS_INITIATED_BU = "IS_INITIATED_BU",
  ACCEPTED_BUSINESS_UNIT_LIST = "ACCEPTED_BUSINESS_UNIT_LIST",
  CLEAR_REGION_LIST = "CLEAR_REGION_LIST",
  CLEAR_BUSINESSUNIT_LIST_BY_UID = "CLEAR_BUSINESSUNIT_LIST_BY_UID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IBusinessUnitListBYID {
  type: ActionType.BUSINESS_UNIT_LIST_USER_ID;
  payload: IBusinessUnitList[];
}
export interface IRegionByBusinessUnit {
  type: ActionType.REGION_LIST_BY_BUSINESS_UNIT;
  payload: IRegionList[];
}
export interface ICountryByRegion {
  type: ActionType.COUNTRY_LIST_BY_REGION;
  payload: ICountryList[];
}

export interface IAllBusinessUnitList {
  type: ActionType.ALL_BUSINESS_UNIT_LIST;
  payload: IBusinessUnitList[];
}
export interface IProjectDetailsByPid {
  type: ActionType.PROJECT_DETAILS_BY_PID;
  payload: IProjectDetail[];
}
export interface IAcceptedBusinessUnitList {
  type: ActionType.ACCEPTED_BUSINESS_UNIT_LIST;
  payload: IBusinessUnitList[];
}
export interface ICheckInitiatedBU {
  type: ActionType.IS_INITIATED_BU;
  payload: boolean;
}
export interface IResetRegionState {
  type: ActionType.CLEAR_REGION_LIST;
}
export interface IResetBUListByID {
  type: ActionType.CLEAR_BUSINESSUNIT_LIST_BY_UID;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action =
  | IBusinessUnitListBYID
  | IRegionByBusinessUnit
  | IResetRegionState
  | ICountryByRegion
  | IAllBusinessUnitList
  | IProjectDetailsByPid
  | IAcceptedBusinessUnitList
  | IResetReduxState
  | ICheckInitiatedBU
  | IResetBUListByID;
